module.exports = (__webpack_require__(0))(401);


//////////////////
// WEBPACK FOOTER
// delegated ./src/templates/widgets/metadatumView.pug from dll-reference girder_lib
// module id = 221
// module chunks = 0